import { Input, Button, Col, Row } from "reactstrap";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../constants/api.constants";
import { AUTH_BASE_URL } from "../../constants/api.constants";
import { FormattedMessage, useIntl } from "react-intl";
import TooltipHelp from "../Help/ToolTipHelp";

export default function RestoreDeleteStudentWithNoCLass() {
  const intl = useIntl();
  return (
    <div className="container-fluid admin-container">
      <Row>
        <Col className="mb-2">
          <h5 className="no-margin">
            <FormattedMessage id="RestoreStudentWithNoClass" />
            <TooltipHelp
              toolTipText={
                <FormattedMessage id="StudentsWithNoLicenseCannotBeRestoredHere" />
              }
              placement="right"
            />
          </h5>
        </Col>
      </Row>

      <Row>
        <Col xs="3" className="mb-2">
          <p>
            <Input id="student-restore-email" placeholder="email" />
          </p>
          <p>
            <Input id="class-name" placeholder="class name" />
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <Button
            color="primary"
            outline
            onClick={() => {
              var className = document
                .getElementById("class-name")
                .value.trim();

              var userEmail = document
                .getElementById("student-restore-email")
                .value.trim();

              axios
                .post(`${AUTH_BASE_URL}/token/SetLockout`, {
                  email: userEmail,
                  lockout: false,
                })
                .then((res) => {
                  if (res.status === 202) {
                    toast.success(res.data);
                  }
                })
                .catch((err) => {
                  var failMessage = err?.response?.data
                    ? err.response.data
                    : err;
                  toast.warn(failMessage);
                });

              axios
                .post(
                  `${API_BASE_URL}/User/RestoreDeletedStudentWithNoClass?email=${encodeURIComponent(
                    userEmail
                  )}&className=${className}`
                )
                .then((response) => {
                  if (response?.data?.result?.name) {
                    var userName = response.data.result.name;
                    var isDeleted = response.data.result.isDeleted
                      ? intl.formatMessage({ id: "Yes" })
                      : intl.formatMessage({ id: "No" });

                    toast.success(
                      intl.formatMessage(
                        { id: "UserNowHasDeletedStatus" },
                        { userName, status: isDeleted }
                      )
                    );
                  } else {
                    toast.warn(
                      intl.formatMessage({ id: "ServerResponseInvalid" })
                    );
                  }
                })
                .catch((err) => {
                  var failMessage = err?.response?.data
                    ? err.response.data
                    : err;
                  toast.warn(failMessage);
                });
            }}
          >
            <FormattedMessage id="Restore" />
          </Button>
        </Col>
      </Row>
    </div>
  );
}
